/* eslint-disable no-undef */
jQuery(function ($) {
  // when page is fully loaded, remove class making gallery images uncclickable
  $(window).on('load', function () {
    enableGalleryImageClicking()
  })

  // timeout to remove class just in case "load" listener doesn't work
  setTimeout(function () {
    enableGalleryImageClicking()
  }, 8000)
})

function enableGalleryImageClicking () {
  jQuery('.wp-block-gallery.images-not-clickable').removeClass('images-not-clickable')
}
